import {Link} from 'react-router-dom';
import React from 'react';

import {HeadlineH1} from './text/Headlines';
import {RCol, Row} from './Grid';
import {TopBar, TopBarButton, TopBarLeftCol} from './form/FormElements';
import EntityTable from './table/EntityTable';

const _tableConfig = () => {
  return {
    maxRows: 30,
    cols: [
      {
        header: 'Name',
        valueKey: '*',
        method: ({_id, firstName, lastName}) => <Link to={`/user/edit/${_id}`}>{`${firstName} ${lastName}`}</Link>,
        width: '20%',
      },
      {
        header: 'Email',
        valueKey: 'email',
        method: email => email,
        width: '20%',
      },
      {
        header: 'Telefonnummer',
        valueKey: 'phone',
        method: phone => phone,
        width: '20%',
      },
      {
        header: 'Role',
        valueKey: 'role',
        method: role => role,
        width: '20%',
      },
      {
        header: 'Status',
        valueKey: 'userStatus',
        method: userStatus => userStatus,
        width: '20%',
      },
    ],
  };
};

export default ({data, history}) => {
  return (
    <div>
      <TopBar>
        <Row>
          <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
            <HeadlineH1>Benutzer</HeadlineH1>
          </TopBarLeftCol>
          <RCol size={0.7}>
            <TopBarButton onClick={() => history.push('/new/user')} label="Neuer Benutzer" />
          </RCol>
        </Row>
      </TopBar>

      <EntityTable
        tableConfig={_tableConfig()}
        data={data.allUsers}
        showFilter={true}
        msg={'Noch keine Benutzer erstellt'}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Users.js